import { Component, EventEmitter, Inject, Output, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'mandae-simulador-frete-dialog',
  templateUrl: './simulador-frete-dialog.component.html',
  styleUrls: ['./simulador-frete-dialog.component.scss']
})
export class SimuladorFreteDialogComponent implements AfterViewInit {
  public showResults = false;
  public isSimulating = false;

  @Output()
  public simulationComplete = new EventEmitter<any>();

  @ViewChild('scrollContainer', { read: ElementRef })
  private readonly scrollContainer?: ElementRef;

  constructor(
    private readonly dialogRef: MatDialogRef<SimuladorFreteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public ngAfterViewInit(): void {
    // Configurar observador de mudanças na altura do conteúdo
    this.setupScrollObserver();
  }

  public onClose(): void {
    this.dialogRef.close();
  }

  public onSimulationStart(): void {
    this.isSimulating = true;
    this.showResults = true;
    // Redimensionar modal para incluir espaço do resultado - altura aumentada
    this.dialogRef.updateSize('1300px', '85vh'); // Aumentado para 85vh para comportar novos produtos

    // Aguardar um momento e forçar recálculo do scroll
    setTimeout(() => {
      this.ensureScrollWorksCorrectly();
    }, 100);
  }

  public onSimulationComplete(result: any): void {
    // Processar o resultado da simulação
    console.log('Simulação completa:', result);
    this.isSimulating = false;

    // 🎯 EMITIR EVENTO PARA COMUNICAÇÃO DIRETA NO ANGULAR
    this.simulationComplete.emit(result);
    console.log('Evento simulationComplete emitido para comunicação Angular');

    // Preparar dados dos serviços calculados
    let servicosCalculados = [];
    if (result.resultado && result.resultado.shippingServices && result.resultado.shippingServices.length > 0) {
      servicosCalculados = result.resultado.shippingServices.map(servico => ({
        codigo: this.mapearCodigoServico(servico.name),
        nomeFormatado: servico.name,
        nomeExibicao: servico.name,
        disponivel: true,
        prazoMaximo: servico.days,
        preco: servico.price,
        indicadorPreco: servico.price || 0 // Adicionar propriedade para orderBy
      }));
    } else if (result.resultado && result.resultado.shippingServicesBefore && result.resultado.shippingServicesBefore.length > 0) {
      servicosCalculados = result.resultado.shippingServicesBefore.map(servico => ({
        codigo: this.mapearCodigoServico(servico.name),
        nomeFormatado: servico.name,
        nomeExibicao: servico.name,
        disponivel: true,
        prazoMaximo: servico.days,
        preco: servico.price,
        indicadorPreco: servico.price || 0 // Adicionar propriedade para orderBy
      }));
    }

    console.log('Estrutura dos serviços calculados:', servicosCalculados);

  }

  private mapearCodigoServico(nomeServico: string): string {
    const mapeamento: {[key: string]: string} = {
      'Econômico': 'Pac',
      'Rápido': 'Sedex',
      'PAC': 'Pac',
      'SEDEX': 'Sedex'
    };
    return mapeamento[nomeServico] || nomeServico;
  }

  /**
   * Configura um observador para detectar mudanças no conteúdo e ajustar o scroll
   */
  private setupScrollObserver(): void {
    // Usar MutationObserver para detectar quando novos produtos são adicionados
    const targetNode = document.querySelector('mat-dialog-content .produtos-scrollable');

    if (targetNode) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Novo produto foi adicionado, ajustar scroll
            setTimeout(() => {
              this.scrollToLastProduct();
            }, 150); // Aguardar animação do novo produto
          }
        });
      });

      observer.observe(targetNode, {
        childList: true,
        subtree: true
      });
    }
  }

  /**
   * Força o recálculo correto do scroll na modal
   */
  private ensureScrollWorksCorrectly(): void {
    const scrollContainer = document.querySelector('mat-dialog-content .produtos-scrollable');

    if (scrollContainer) {
      const htmlElement = scrollContainer as HTMLElement;
      // Garantir que o container seja o alvo do scroll
      htmlElement.style.scrollBehavior = 'smooth';
      // Forçar reflow para atualizar altura (força recálculo do layout)
      const _ = htmlElement.offsetHeight;
      // Garantir que o scroll alcance o final do conteúdo
      htmlElement.scrollTo({ top: htmlElement.scrollHeight, behavior: 'smooth' });
    }
  }

  /**
   * Faz scroll até o último produto adicionado
   */
  private scrollToLastProduct(): void {
    const scrollContainer = document.querySelector('mat-dialog-content .produtos-scrollable');
    const lastProduct = document.querySelector('mandae-simulador-frete-produto:last-of-type');

    if (scrollContainer) {
      const htmlElement = scrollContainer as HTMLElement;
      // Scroll explicitamente no container correto
      htmlElement.scrollTo({ top: htmlElement.scrollHeight, behavior: 'smooth' });

      // Fallback: caso necessário, tenta alinhar o último produto no fim do container
      if (lastProduct) {
        const containerRect = htmlElement.getBoundingClientRect();
        const productRect = lastProduct.getBoundingClientRect();
        if (productRect.bottom > containerRect.bottom || productRect.top < containerRect.top) {
          (lastProduct as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
        }
      }
    }
  }

  /**
   * Método público para ser chamado quando um novo produto é adicionado
   */
  public onProductAdded(): void {
    setTimeout(() => {
      this.scrollToLastProduct();
      this.ensureScrollWorksCorrectly();
    }, 200);
  }
}
